export default {
  container: {
    display: 'flex',
    justifyContent: 'center'
  }
}
